module.exports = __webpack_public_path__ + "static/media/raychan-1560719-unsplash.b1a55095.jpg";